import { ChatType } from '@tribeplatform/gql-client/types'
import { useChatContext } from '@tribeplatform/react-components/Messaging'
import { IconButton } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { ChatImage } from './components/ChatImage.js'
import {
  IsTypingIndicatorHoC,
  IsTypingIndicatorRenderer,
} from './components/IsTypingIndicator.js'

interface Props {
  name: string
  imageUrl: string
  chatId: string
}

export const GroupChatHeader = ({ name, imageUrl, chatId }: Props) => {
  const { toggleShowChatDetails, showChatDetails } = useChatContext()

  return (
    <div className="flex items-center min-w-0 max-h-full relative flex-grow gap-2">
      <div className="cursor-pointer" onClick={() => toggleShowChatDetails()}>
        <ChatImage
          size="2.5x"
          name={name}
          imageUrl={imageUrl}
          type={ChatType.Group}
        />
      </div>
      <div className="flex grow-0 basis-full max-h-full relative flex-wrap items-center overflow-hidden">
        <div className="flex flex-col truncate">
          <div
            className="font-medium text-lg truncate text-content cursor-pointer leading-5"
            translate="no"
            onClick={() => toggleShowChatDetails()}
          >
            {name}
          </div>
          <IsTypingIndicatorHoC chatId={chatId}>
            {(props, deferrerProps, ref) => (
              <IsTypingIndicatorRenderer
                ref={ref}
                currentProps={props}
                deferredProps={deferrerProps}
                className="flex basis-full shrink-0 text-xs"
              />
            )}
          </IsTypingIndicatorHoC>
        </div>
      </div>
      {!showChatDetails && (
        <IconButton
          variant="tertiaryNeutral"
          icon={<SvgIcon name="dots-horizontal" />}
          onClick={() => toggleShowChatDetails()}
        />
      )}
    </div>
  )
}
